import MercadoPagoMixin from './MercadoPagoMixin'

export default {
    mixins: [
        MercadoPagoMixin
    ]
}